import React from "react";

import TAG_TYPE_STYLES from "./TagTypes.const";

const TagTypeRenderer = React.memo(function TagTypeRenderer({ data }) {
  const { Type, TagType } = data;
  return (
    <span className="tag-type" style={TAG_TYPE_STYLES[Type]}>
      {TagType}
    </span>
  );
});

export default TagTypeRenderer;
